type Props = {
  // Bold user-facing copy on the white emphasis card.
  headline: string;
  // Gray technical detail line(s) under the card (raw status/code/message).
  detail?: string;
  onRetry?: () => void;
};

export function ErrorPanel({ headline, detail, onRetry }: Props): JSX.Element {
  return (
    <div className="w-full max-w-card mx-auto flex flex-col items-stretch gap-3">
      <div className="bg-primary text-canvas rounded-xl p-4 text-[16px] font-medium leading-snug">
        {headline}
      </div>
      {detail ? (
        <div className="text-secondary text-hint break-words leading-snug">{detail}</div>
      ) : null}
      {onRetry ? (
        <button
          type="button"
          onClick={onRetry}
          className="self-start mt-1 px-4 h-11 rounded-full border border-border text-primary active:bg-surface-2 text-hint"
        >
          重试
        </button>
      ) : null}
    </div>
  );
}
